import styled from "styled-components";

import { Select, SelectItem } from "@aidron/aidron-ds";

import { CustomText } from "../../StyledComponents/styleComponents.index";

import PropTypes from 'prop-types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: columns;
  align-items: center;
`;

export function SortSelect({ label, selected, options, onChange }) {

  return (
    <Wrapper>
      <CustomText fontSize={['0.3rem', '0.7rem', '1.1rem']} weight="bold" margin="0 1rem 0 0">
        {label}
      </CustomText>
      <Select label="" selected={selected} handleChange={e => onChange(e)}>
        {options.map(option => (
          <SelectItem value={option.value} key={option.value}>
            {option.displayName}
          </SelectItem>
        ))}
      </Select>
    </Wrapper>
  );
}

SortSelect.propTypes = {
  label: PropTypes.string,
  selected: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      displayName: PropTypes.string
    })
  )
}